export default __webpack_public_path__ + "static/media/blog-home-image.2cc71cd0.png";